export default "__VITE_ASSET__Djclc2n0__"